<template>
	<AppDialog :dialogName="dialogName" width="620">
		<div class="create-sync-group px-16">
			<div class="top py-10">
				<div class="title">{{ title }}</div>
				<div class="sub-title">Synced groups let you bring users and structures from your apps</div>
			</div>
			<div class="selection flex-centerize flex-column pb-16">
				<div class="app pb-4">
					<div>Choose app</div>
					<AppSelect
						class="select"
						outlined
						dense
						v-model="appSelected"
						:items="appItems"
						item-text="service_name"
						return-object
						:disabled="!!defaultServiceId"
					>
						<template v-slot:selection="{ item }">
							<div class="selected-app flex-centerize">
								<IntegrationIcon :integrationName="item.service_slug" :size="serviceIconWidth" :padding="serviceIconPadding" />
								<div class="integration-name">{{ item.service_name }}</div>
							</div>
						</template>
						<template v-slot:item="{ item }">
							<div class="selection-row flex-centerize">
								<IntegrationIcon :integrationName="item.service_slug" :size="serviceIconWidth" :padding="serviceIconPadding" />
								<div class="integration-name">{{ item.service_name }}</div>
							</div>
						</template>
					</AppSelect>
				</div>
				<div class="profile" v-if="appSelected">
					<div>Connect an account</div>
					<ProfileSelector
						:serviceId="appSelected.id"
						:serviceVersionId="appSelected.version"
						@select-profile="selectAccountConnection"
						:profileId="profileSelectedId"
						v-if="appSelected"
						:shouldOpenProjectOptions="false"
					/>
				</div>
			</div>
			<div class="button flex-centerize">
				<v-btn class="btn next-btn" :disabled="!canGoNext" @click="next">Next</v-btn>
			</div>
		</div>
	</AppDialog>
</template>

<script>
import { mapGetters } from 'vuex';

import AppDialog from '../AppDialog/AppDialog';
import { getAllServicesList } from '@/store/modules/apps/getters';
import { groups } from '@/store/modules/accountGroups/getters';
import AppDialogManagerService from '../AppDialogManager/app-dialog-manager-service';
import ProfileSelector from '@/components/common/ProfileSelector';
import { ServiceType } from '@ply-io/ply-front-shared-utilities';
export default {
	name: 'SyncedGroupDialog',
	components: {
		AppDialog,
		ProfileSelector,
	},
	props: {
		defaultProfileId: { type: [String, Number], required: false },
		defaultServiceId: { type: [String, Number], required: false },
		isUpdate: { type: Boolean, default: false },
		group: { type: Object, default: null },
		dialogPromiseHandlers: { type: Object },
	},
	computed: {
		...mapGetters([getAllServicesList.fullPath, groups.fullPath]),
		canGoNext() {
			return this.appSelected && this.profileSelectedId;
		},
		appItems() {
			const allServices = this[getAllServicesList.fullPath];
			if (this.defaultServiceId) {
				return allServices.filter((x) => x.id === this.defaultServiceId);
			}
			return allServices.filter((x) => x.type === ServiceType.Integration && x.user_matching_enabled);
		},
		syncedServices() {
			return this[groups.fullPath].filter((x) => x.synced).map((x) => x.synced.service);
		},
		title() {
			return this.isUpdate ? 'Update synced group' : 'New synced group';
		},
	},
	methods: {
		async next() {
			if (this.canGoNext) {
				const res = await AppDialogManagerService.openChooseSyncedGroupTypeAndUsersDialog({
					profileId: this.profileSelectedId,
					service: this.appSelected,
					isUpdate: this.isUpdate,
					group: this.group,
				});
				this.dialogPromiseHandlers.resolve(res);
				AppDialogManagerService.closeCurrentDialog();
			}
		},
		selectAccountConnection(accountConnectionId) {
			this.profileSelectedId = accountConnectionId;
		},
	},
	async mounted() {
		if (this.defaultServiceId) {
			this.appSelected = this.appItems[0];
		}
	},

	data() {
		return {
			appSelected: undefined,
			profileSelectedId: this.defaultProfileId,
			serviceIconWidth: 30,
			serviceIconPadding: 10,
			dialogName: 'SyncedGroupDialog',
		};
	},
};
</script>

<style scoped lang="scss">
.create-sync-group {
	height: 500px;
	.title {
		font-weight: 600;
		font-size: x-large;
	}
	.sub-title {
		font-size: small;
	}
	.selection {
		font-size: 12px;
		.select {
			width: 450px;
		}
	}
	.next-btn {
		background-color: var(--forth-color);
		color: white;
		border-radius: 3px;
	}
}
.integration-name {
	padding: 10px;
}
</style>
